import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {

  public title: string;
  public message: string;
  public anotherMessage: string;
  public confirmMessage: string;
  public cancelButton: boolean;
  public okButtonText: string;

  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: any) {
  }

  ngOnInit(): void {
    this.title = this.dialogData.title;
    this.message = this.dialogData.message;
    this.anotherMessage = this.dialogData && this.dialogData.anotherMessage ? this.dialogData.anotherMessage : null;
    this.confirmMessage = this.dialogData && this.dialogData.confirmMessage ? this.dialogData.confirmMessage : null;
    this.okButtonText = this.dialogData && this.dialogData.okButtonText ? this.dialogData.okButtonText : null;
    if (this.dialogData.cancelButton === false) {
      this.cancelButton = this.dialogData.cancelButton;
    } else {
      this.cancelButton = true;
    }
  }
}
